// extracted by mini-css-extract-plugin
export default {"social-share-buttons":"_3h9nB","socialShareButtons":"_3h9nB","social-share-group":"_2qNx-","socialShareGroup":"_2qNx-","social-share-button":"_1E8DW","socialShareButton":"_1E8DW"};